import { Image, VideoPoster, Video as Video$1 } from '@ccg/core';
import React$1, { useState } from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../Icon/Icon.js';
import Typography$1 from '../Typography/Typography.js';
import StyledVideo from './Video.style.js';

const Video = ({
  videoUrl,
  image
}) => {
  const [isInit, setIsInit] = useState(false);
  return /*#__PURE__*/React$1.createElement(StyledVideo, null, !isInit && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    onClick: () => setIsInit(true),
    "aria-label": "Play Video",
    className: "video__play-button"
  }, image ? /*#__PURE__*/React$1.createElement(Image, _extends({}, image, {
    ratio: image.width && image.height ? `${image.width}:${image.height}` : '16:9',
    sizes: "95vw",
    lazy: true
  })) : /*#__PURE__*/React$1.createElement(VideoPoster, {
    url: videoUrl,
    className: "video__poster"
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "video__play-overlay"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "video__button-label",
    as: "div"
  }, "Play", /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "play"
  })))), isInit && /*#__PURE__*/React$1.createElement(Video$1, {
    url: videoUrl,
    autoplay: true
  }));
};

Video.propTypes = {
  videoUrl: PropTypes$1.string.isRequired,
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string,
    sizes: PropTypes$1.string,
    width: PropTypes$1.number,
    height: PropTypes$1.number
  })
};
Video.defaultProps = {
  image: null
};

export default Video;
